import { supabase } from "./supabase";
import { TB_MOVIE, TB_POST, TB_POST_SCENE } from "../config";

const getAllPosts = async () => {
  const { data, error } = await supabase
    .from(TB_POST)
    .select(
      `
      pid, 
      mid, 
      description, 
      spoiler, 
      type,
      ${TB_MOVIE}(
        mid, 
        poster
      )`
    )

    .order("pid", { ascending: false });

  if (error) {
    console.error("Error fetching all posts:", error.message);
    throw error;
  }

  return data;
};

const getPost = async (postId) => {
  const { data, error } = await supabase
    .from(TB_POST)
    .select(
      `
      pid,
      type,
      description,
      spoiler,
      mid,
      ${TB_MOVIE} (
        mid,
        title,
        poster
      ),
      ${TB_POST_SCENE} (
        pid,
        scene_one,
        scene_two
      )
    `
    )
    .eq("pid", postId)
    .single();

  if (error) {
    console.error("Error fetching post:", error.message);
    throw error;
  }

  return data;
};

export { getAllPosts, getPost };
